import React from 'react';
import { Button, Tooltip } from 'antd';

export default class ArchiveRequest extends React.Component {
	render() {
		return (
			<Tooltip title="Archive Request">
				<Button shape="circle" onClick={this.archiveRequest}>
					<div className="icon-archive archive-request" />
				</Button>
			</Tooltip>
		);
	}

	archiveRequest = () => {
		alert('Not yet operational');
	};
}
